import {Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NameId, PAGES } from "src/app/types/akit-testbench-types";

@Component({
    selector: "app-akit-header",
    templateUrl: "./akit-header.component.html",
    styleUrls: ["./akit-header.component.less"],
    standalone: false
})
export class AkitHeaderComponent implements OnInit {
    @Input() title: string = "<title>";
    @Input() enableSubHeader: boolean = false;
    
    pages = PAGES;
    currentPage: NameId;


    constructor(
        private router: Router,
    ) {}

    ngOnInit(): void {
        if(this.title) {
            this.currentPage = this.pages.find(_p => _p.id == this.title);
        }
    }
    pageClicked(page:string) {
        this.router.navigate([page]);
    }

    getTitle() {
        let page = this.pages.find(_p => _p.id == this.title);
        if(page) return page.name;
        else return "Invalid title";
    }
}
